import React, { useEffect, useState } from "react";
import { Route, Link, Switch } from "react-router-dom";
import quizService from "../../services/quiz.service";
import QuizPage from "./quiz-page.component";
import { Label, Button, Modal, Checkbox, DropDownInput, Input } from '../../util/ui'
import CreateQuizModal from "./quiz.createQuiz.component";
import QuizListCard from "./quiz.list.card.component";
import '../../util/Quiz.css';
import Select from 'react-select'
import { Card, ProgressBar } from 'react-bootstrap';

const QuizList = () => {
    const [quizSelected, setQuizSelected] = useState(false);
    const [quizzes, setQuizzes] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentQuiz, setCurrentQuiz] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const role = JSON.parse(localStorage.getItem("user")).role;
    const [quizCourse, setQuizCourse] = useState("");
    const [selectedTopic, setSelectedTopic] = useState(null);
    const [topicQuizzes, setTopicQuizzes] = useState({});
    const topic_options = [
        // { value: '', label: '-' },
        { value: 'query', label: 'Query' },
        { value: 'data_cln', label: 'Data Cleaning' },
        { value: 'data_pro', label: 'Data Preprocessing' },
        { value: 'data_viz', label: 'Data Visualization' },
        { value: 'feat_eng', label: 'Feature Engineering' },
        { value: 'feat_sel', label: 'Feature Selection' },
        { value: 'analysis', label: 'Analysis' }
    ]
    useEffect(() => {
        const fetchQuizzes = async () => {
            const author = JSON.parse(localStorage.getItem("user")).username;
            try {
                const response = await quizService.getQuizzes(author);
                const all_quizzes = response.quizzes.filter(element => element != null);
                setQuizzes(all_quizzes);
                const groupedQuizzes = all_quizzes.reduce((acc, quiz) => {
                    if (!acc[quiz.course]) acc[quiz.course] = [];
                    acc[quiz.course].push(quiz);
                    return acc;
                }, {});
                setTopicQuizzes(groupedQuizzes);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching quizzes: ", error);
                setLoading(false);
            }
        };

        fetchQuizzes();
    }, []);

    //   const navigate = useNavigate();

    const handleQuizClick = async (quiz) => {
        // const author = JSON.parse(localStorage.getItem("user")).username;
        // try {
        //   const cur_quiz = await quizService.takeQuiz(author, quiz._id);
        //   setQuizSelected(true);
        //   setCurrentQuiz(cur_quiz);
        // } catch (error) {
        //   console.error("Error starting quiz:", error);
        // }

        // navigate('/quiz/'+quiz._id);

    };

    const handleTopicClick = (topic) => {
        setSelectedTopic(topic);
        setQuizCourse(topic);
    };

    const deleteQuiz = async (quizId) => {
        const confirmed = window.confirm("Are you sure you want to delete this quiz?");
        if (confirmed) {
            try {
                await quizService.deleteQuiz(quizId);
                setQuizzes(quizzes.filter(quiz => quiz._id !== quizId));
            } catch (error) {
                console.error("Error deleting quiz:", error);
            }
        }
    };

    const handleCreateQuiz = async (quizObj) => {
        const author = JSON.parse(localStorage.getItem("user")).username;
        try {
            await quizService.createQuiz(quizObj)

            const response = await quizService.getQuizzes(author);
            setQuizzes(response.quizzes);

        } catch (error) {
            console.error("Error creating quiz:", error);
        }
    }

    if (loading) {
        return <p>Loading quizzes...</p>;
    }
    // return (
    // <div className="container">
    //     <div className="header">
    //     <input
    //         className="search-input"
    //         placeholder="search quizzes"
    //     />
    //     <Select options={topic_options}
    //       placeholder="Filter by Topic ..."
    //       required
    //       // defaultValue={topic_options.find(({ value }) => value === quizCourse)}
    //       onChange={(e) => setQuizCourse(e.value)}/>
    //     {(role==="admin" || role==="Instructor") &&
    //     <button
    //         className="create-button"
    //         onClick={() => setShowCreateModal(true)}
    //     >
    //         Create Quiz
    //     </button>
    //     }
    //     </div>
    //     <div className="quiz-list">
    //     {quizzes &&
    //       quizzes
    //       .filter(obj => !quizCourse || obj.course === quizCourse) // Filter quizzes based on quizCourse
    //       .map((obj, i) => (
    //           <QuizListCard index={i} quiz={obj} handleQuizClick={handleQuizClick} key={i} deleteQuiz={deleteQuiz}/>
    //         ))
    //     }
    //     </div>
    //     {showCreateModal && (
    //         <CreateQuizModal
    //             isOpen={showCreateModal}
    //             setIsOpen={setShowCreateModal}
    //             onCreateQuiz={handleCreateQuiz}
    //         />
    //     )}
    // </div>
    // );

    // Function to calculate the average progress of quizzes for a topic
    const calculateAverageProgress = (quizzes) => {
        if (!quizzes || quizzes.length === 0) return 0;
        const totalProgress = quizzes.reduce((acc, quiz) => acc + quiz.progress, 0);
        return totalProgress / quizzes.length;
    };

    // Function to get the variant color for the progress bar
    const getProgressVariant = (progress) => {
        if (progress < 60) return 'danger';
        if (progress < 80) return 'warning';
        return 'success';
    };

    return (
        <div className="container">
            {!selectedTopic ? (
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', gap: '20px' }}>
                    {/* {topic_options.map(({ value, label }) => (
              <Card key={value} style={{ width: '300px', height: '150px', marginBottom: '20px', cursor: 'pointer' }} onClick={() => handleTopicClick(value)}>
                <Card.Body style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                  <Card.Title style={{ color: 'blue', fontSize: '1.5em' }}>
                    {label}
                  </Card.Title>
                  <Card.Text style={{ fontSize: '1em' }}>
                    Number of Quizzes: <span style={{ color: 'red' }}>{topicQuizzes[value]?.length || 0}</span>
                  </Card.Text>
                </Card.Body>
              </Card>
            ))} */}
                    {topic_options.map(({ value, label }) => {
                        const quizzes = topicQuizzes[value] || [];
                        const averageProgress = calculateAverageProgress(quizzes); // Calculate the average progress

                        return (
                            <Card
                                key={value}
                                style={{ width: '300px', height: '200px', marginBottom: '20px', cursor: 'pointer' }}
                                onClick={() => handleTopicClick(value)}
                            >
                                <Card.Body
                                    style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}
                                >
                                    <Card.Title style={{ color: 'blue', fontSize: '1.5em' }}>
                                        {label}
                                    </Card.Title>
                                    <Card.Text style={{ fontSize: '1em' }}>
                                        Number of Quizzes: <span style={{ color: 'red' }}>{quizzes.length}</span>
                                    </Card.Text>

                                    {/* Progress Bar showing the average progress */}
                                    {role === "Student" && (
                                        <div style={{ width: '100%', marginTop: '10px' }}>
                                            <p>Progress:</p>
                                            <ProgressBar
                                                now={averageProgress}
                                                label={`${Math.round(averageProgress)}%`}
                                                variant={getProgressVariant(averageProgress)}
                                                style={{ height: '1rem' }} // Set the height to 1rem
                                            />
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        );
                    })}
                </div>
            ) : (
                <div>
                    <button onClick={() => setSelectedTopic(null)}
                        style={{ marginRight: '20px', marginBottom: '1px' }}
                        className="btn btn-secondary">
                        Back to Topics
                    </button>

                    {role === "admin" || role === "Instructor" ? (
                        <button
                            className="create-button"
                            onClick={() => setShowCreateModal(true)}
                        >
                            Create Quiz
                        </button>
                    ) : null}

                    <div className="quiz-list">
                        {topicQuizzes[selectedTopic] && topicQuizzes[selectedTopic]
                            .map((obj, i) => (
                                <QuizListCard index={i} quiz={obj} handleQuizClick={handleQuizClick} key={i} deleteQuiz={deleteQuiz} />
                            ))}
                    </div>
                    {showCreateModal && (
                        <CreateQuizModal
                            isOpen={showCreateModal}
                            setIsOpen={setShowCreateModal}
                            onCreateQuiz={handleCreateQuiz}
                        />
                    )}
                </div>
            )}
        </div>
    );

};

export default QuizList;